import React from 'react'
import {store} from './utilities'
import {Provider} from 'react-redux'
import TopLevelState from './TopLevelState'

import './Forms.scss'

export default function EntryPoint(props) {
  return (
    <Provider store={store}>
      <div className="forms">
        <TopLevelState {...props} />
      </div>
    </Provider>
  )
}
